export default __webpack_public_path__ + "static/media/gallery_17.ec503e3c.jpg";